import api from '../callApi';

const formatAddress = googleAddress => {
    if (
        !googleAddress ||
        !googleAddress.street ||
        !googleAddress.country ||
        !googleAddress.postalCode
    )
        return null;
    return {
        streetNo: googleAddress.streetNo,
        street: googleAddress.street,
        city: googleAddress.homeCity,
        state: googleAddress.state,
        zipCode: googleAddress.postalCode,
        country: googleAddress.country
    };
};

export const getRequiredFormFields = representativesObject => {
    if (!representativesObject.representative) return Promise.resolve([]);
    var bioguideIds = representativesObject.representative
        .map(rep => rep.bioguideId)
        .filter(id => !!id);
    if (!bioguideIds.length) return Promise.resolve([]);
    const url = `Localization/GetSenatorEmailFormFields`;

    return api.post(url, { bioguideIds });
};

export const getRepresentatives = (endUserLocation, address, representativeSearch) => {
    const data = { representativeSearch };
    if (address) data.address = formatAddress(address);
    if (endUserLocation) data.location = endUserLocation;
    const url = `Localization/GetRepresentatives`;

    return api.post(url, data).then(json => {
        if (!json) return null;
        json.representatives.forEach(rep => {
            if (rep.photoUrl) {
                const imagePreload = new Image();
                imagePreload.src = rep.photoUrl;
            }
        });
        return {
            representative: json.representatives, //legacy, could be renamed in a refactor
            address: json.address
        };
    });
};

export default getRepresentatives;
